import {
  EDITOR_RIGHT_BAR_WIDTH,
  EDITOR_TOP_BAR_HEIGHT,
} from '../../cnst/editor.cnst'
import { useEditorActions, useEditorData, useEditorUi } from '../../utils/hooks'
import InfoBox from '../InfoBox'
import EditorBarRightContent from './EditorBarRightContent'
import { Button, Icon } from '@bm-js/atlascloud-ui'
import {
  ContentType,
  GridData,
  LucideIconName,
  STATIC_CONTENT_TYPE_NAMES,
  TOP_LEVEL_CONTENT_TYPE_NAMES,
} from '@bm-js/atlascloud-shared'
import { useTr } from '../../utils/useTr'
import { TrKey } from '../../cnst/translations/trKey.cnst'
import { contentTypeTrKeyMap } from '../../utils/tr.util'

const EditorBarRight = () => {
  const { tr } = useTr()
  const { activeContent, activePage } = useEditorData()
  const { setActiveContent, patchActivePage } = useEditorActions()
  const { fullScreen } = useEditorUi()

  if (!activeContent) return null

  const removeContent = () => {
    if (!activePage) return

    // Handle top level content types
    if (TOP_LEVEL_CONTENT_TYPE_NAMES.includes(activeContent.name)) {
      const newContent = activePage.content.filter(
        (c) => c.uuid !== activeContent.uuid
      )
      patchActivePage({ content: newContent })

      // Handle nested content types
    } else {
      const newContent = activePage.content.map((content) => {
        if (STATIC_CONTENT_TYPE_NAMES.includes(content.name)) {
          return content
        }
        const gridContent = content as ContentType<GridData>
        return {
          ...gridContent,
          data: {
            ...gridContent.data,
            content: gridContent.data.content.map((section) =>
              section.filter((content) => content.uuid !== activeContent.uuid)
            ),
          },
        }
      })
      patchActivePage({ content: newContent })
    }
    setActiveContent(null)
  }

  return (
    <div
      className='fixed z-20 border-l bg-white border-slate-500 transition-all'
      style={{
        top: EDITOR_TOP_BAR_HEIGHT,
        right: fullScreen ? '-100%' : 0,
        bottom: 0,
        width: EDITOR_RIGHT_BAR_WIDTH,
      }}
    >
      <div className='flex justify-between items-center border-b border-slate-500 px-2 py-4'>
        <div className='flex items-center gap-2'>
          <p>{`${tr(TrKey.edit)} ${tr(contentTypeTrKeyMap[activeContent.name]).toLowerCase()}`}</p>
          <InfoBox
            text={tr(TrKey.editorRightEditingTooltip, {
              contentType: tr(
                contentTypeTrKeyMap[activeContent.name]
              ).toLowerCase(),
            })}
            w={300}
          />
        </div>
        <button
          className='right-bar-close text-red-500'
          onClick={() => setActiveContent(null)}
        >
          <Icon name={LucideIconName.X} className='size-5' />
        </button>
      </div>

      <div className='px-2 pt-2 pb-48 overflow-y-scroll max-h-full'>
        <EditorBarRightContent />
      </div>
      <div className='flex gap-2 justify-end absolute bottom-0 right-0 px-2 py-4 bg-white border-t border-slate-500 w-full'>
        <Button onClick={() => setActiveContent(null)}>{tr(TrKey.done)}</Button>
        <Button danger onClick={removeContent}>
          {tr(TrKey.remove)}
        </Button>
      </div>
    </div>
  )
}

export default EditorBarRight
